// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import CommonHeading from "../../components/commonComponents/commonHeading";
import CommonBreadcrumbs from "../../components/commonComponents/CommonBreadcrumbs";
import ButtonComponents from "../../components/commonComponents/ButtonComponents";
import TextFieldComponent from "../../components/commonComponents/TextFieldComponent";
import ConfirmationDialog from "../../components/commonComponents/DialogComponents";
import FundsBlock from "./FundsBlock";
import { useLocation, useNavigate } from "react-router-dom";
import BankAccountRadioGroup from "../../components/BankAccountRadioGroup";
import { useAuth } from "../../services/AuthContext";
import {
  cancelWithdrawalFundRequest,
  getFund,
  getWithdrawalHistory,
  withdrawalFund,
} from "../../redux/slice/fundAndTransactionSlice";
import { generateGUID } from "../../utils/guidGenerator";
import { useDispatch, useSelector } from "react-redux";
import NumberFormatter from "../../utils/NumberFormater";
import DateFormatter from "../../utils/DateFormater";
import { toast } from "react-toastify";
import { numberToWords } from "../../utils/formatUtils";
import { textColor } from "../../utils/commonstyle";
import { getIsWiredTransfer } from "../../utils/config";
import { BorderColor } from "@mui/icons-material";
import { BackButton } from "../../components/commonComponents/BackButton";
const WithdrawalFunds = () => {
  const historyRef = useRef();
  const inputRef = useRef();
  const [selectedId, setSelectedId] = useState(0);
  const isWired = getIsWiredTransfer();
  const [withdrawalId, setWithdrawalId] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [amount, setAmount] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { investorId: user } = useAuth();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [error, setError] = useState("");
  const withdrawalHistory = useSelector(
    (store) => store.fund.withdrawalHistory
  );
  const availableFund = useSelector(
    (store) => store.fund.fundsData.availableFund
  );

  const loadingCancel = useSelector((store: RootState) => store.fund.loadingCancel)
  const handleAccountChange = (event) => setSelectedId(event.target.value);
  useEffect(() => {
    if (user.investorId) {
      dispatch(getWithdrawalHistory(user.investorId));
    }
  }, [user.investorId]);
  // useEffect(() => {
  //   if (withdrawalRequest) {
  //     const elementPosition = historyRef.current.offsetTop; // Get the element's top position
  //     const offset = 60; // Space to leave above the element in percentcage
  //     const scrollToPosition = (elementPosition * offset) / 100; // calculating position
  //     window.scrollTo({
  //       top: scrollToPosition,
  //       behavior: "smooth", // Smooth scrolling effect
  //     });
  //   }
  // }, [withdrawalRequest]);

  const formatAmount = (value) => {
    if (value === "") return ""; // Return empty string if no value
    const numberValue = parseFloat(value);
    return isNaN(numberValue)
      ? ""
      : new Intl.NumberFormat("en-US").format(numberValue);
  };

  const handleAmountChange = (e) => {
    const input = e.target;
    let rawValue = input.value.replace(/[^0-9]/g, ""); // Remove any non-digit characters
    const selectionStart = input.selectionStart;

    // Count digits before the cursor in the old value
    let digitsBeforeCursor = 0;
    for (let i = 0; i < selectionStart; i++) {
      if (/\d/.test(input.value[i])) digitsBeforeCursor++;
    }

    // Check if the value is valid (only digits, no decimals, no special characters)
    if (/^\d*$/.test(rawValue)) {
      if (rawValue === "") {
        setAmount(""); // Set the amount to empty if the value is deleted entirely
      } else {
        // Format the value and update state
        const formattedAmount = formatAmount(rawValue);
        setAmount(formattedAmount);
        // Find the new cursor position: after the same number of digits
        let newCursor = 0, digitCount = 0;
        while (newCursor < formattedAmount.length && digitCount < digitsBeforeCursor) {
          if (/\d/.test(formattedAmount[newCursor])) digitCount++;
          newCursor++;
        }
        
        // If we're at the end of the input and adding a digit, stay at the end
        if (selectionStart === input.value.length && digitsBeforeCursor === rawValue.length - 1) {
          newCursor = formattedAmount.length;
        }
        
        setTimeout(() => {
          // Access the actual input element inside the TextFieldComponent
          const inputElement = inputRef.current?.querySelector('input') || input;
          if (inputElement) {
            inputElement.setSelectionRange(newCursor, newCursor);
          }
        }, 0);
      }
      setError(parseInt(rawValue) <= 0); // Check if the value is less than or equal to 0
    } else {
      setError(true); // Set error if the input is invalid (contains non-numeric characters)
    }
  };
  const handleWithdrwalFunds = async () => {
    try {
      setError(null);
      setSubmitting(true);
      const newGUID = generateGUID();
      const withdrawalAmount = parseFloat(amount.replace(/[^0-9.]/g, ""));
      if (withdrawalAmount > 0) {
        if (withdrawalAmount > availableFund) {
          return setError(
            "The withdrawal amount cannot be more than available funds."
          );
        }
        const payload = {
          investorId: user.investorId,
          amount: withdrawalAmount,
          action: "sila_withdrawal",
          IdempotencyKey: newGUID,
          inv_Acc_Id: isWired === "0" ? selectedId : undefined,
        };
        const response = await dispatch(withdrawalFund(payload)).unwrap();
        if (response.statusCode === 200) {
          toast.success("Funds withdrawal initiated", {
            className: 'custom-toast'
          });
          setAmount("");
          await dispatch(getWithdrawalHistory(user.investorId)).unwrap();
          dispatch(getFund(user.investorId));
          if (historyRef.current) {
            const elementPosition = historyRef.current.offsetTop; // Get the element's top position
            const offset = 400; // Space to leave above the element in percentcage
            const scrollToPosition = elementPosition - offset; // calculating position
            window.scrollTo({
              top: scrollToPosition,
              behavior: "smooth", // Smooth scrolling effect
            });
          
          }
        }
      } else {
        setError("Amount must be greater than zero");
        const id = setTimeout(() => {
          setError("");
        }, 5000);
        return () => {
          clearTimeout(id);
        };
      }
    } catch (error) {
      if (error?.body?.includes("Insufficient funds")) {
        setError("The withdrawal amount cannot be more than available funds.");
      } else if (error?.body) {
        setError(error.body);
      }
    } finally {
      const id = setTimeout(() => {
        setError("");
      }, 5000);
      setSubmitting(false);
      console.error(error);
      return () => {
        clearTimeout(id);
      };
    }
  };

  const handleOpenDialog = (id) => {
    setWithdrawalId(id);
    setDialogOpen(true);
  };
  const handleCloseDialog = () => setDialogOpen(false);
  const handleConfirmAction = async () => {
    try {
      if (withdrawalId) {
        const payload = {
          id: withdrawalId,
          status: 6, // need to use 6 for cancelling the withdrawal req
        };
        const response = await dispatch(
          cancelWithdrawalFundRequest(payload)
        ).unwrap();
        if (response.statusCode === 200) {
          dispatch(getWithdrawalHistory(user.investorId));
          dispatch(getFund(user.investorId));
          setDialogOpen(false);
          toast.success("Withdrawal request canceled", {
            className: 'custom-toast'
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  const appBreadCrumbs = [
    {
      href: "",
      label: "Home",
      onClick: () => {
        navigate("/home");
      },
    },
    {
      href: "",
      label: "Manage Funds",
      onClick: () => {
        navigate("/managefunds");
      },
    },
  ];
  return (
    <>
    <div className='flex justify-start items-center'>
    <BackButton/>
    </div>
    <Box bgcolor="#f8f8f8">
      {/* Confirmation Dialog */}
      <ConfirmationDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        onConfirm={loadingCancel ? '' : handleConfirmAction}
        sx={{ cursor: loadingCancel ? "not-allowed" : "pointer", background: loadingCancel ? "gray" : "#FF5C39", border: loadingCancel ? "1px solid gray" : "1px solid #FFC39", '&:hover': { backgroundColor: loadingCancel ? 'gray' : "#FFC39" }, }}
        dialogText="Are you sure you want to cancel the withdrawal request?"
      />

      {/* Heading */}
      <CommonHeading sx={{ mb: 1,mt:{sm:3,md:0,xs:1} }} heading="Withdrawal Funds" />

      {/* Breadcrumbs */}
      <CommonBreadcrumbs
        items={appBreadCrumbs}
        final={{ href: "", label: "Withdraw Funds" }}
      />

      {/* FundsBlock */}
      <FundsBlock />

      {/* Account Selection */}
      <Box py={"20px"} px={{ md: 5, xs: 2 }} my={{ md: 3, xs: 1 }} bgcolor="#fff" boxShadow={1}>
        {isWired === "0" && (
          <Box mb={3}>
            <Typography
              mt={"20px"}
              sx={{ fontWeight: 500, fontSize: { xs: 14, md: 18 } }}
              gutterBottom
            >
              Select Destination Account for Withdrawal
            </Typography>
            <BankAccountRadioGroup
              value={selectedId}
              onChange={handleAccountChange}
              setState={setSelectedId}
            />
          </Box>
        )}

        {/* Enter Amount */}
        <Typography variant="h6" fontSize={20} gutterBottom>
          Withdrawal amount
        </Typography>
        <Box display="flex" flexDirection={"column"} mb={2.5}>
          <TextFieldComponent
            error={!!error}
            label="Amount"
            value={amount}
            onChange={handleAmountChange}
            startAdornment={<Typography sx={{ mr: 1 }}>$</Typography>}
            sx={{ width: { xs: "100%", md: "50%" } }}
            size="small"
            inputRef={inputRef}
          />
          <Typography
            sx={{
              fontSize: "14px",
              color: textColor.fontColor,
              fontWeight: 400,
              // mt: 1,
              textAlign: "left",
              fontStyle: "italic",
            }}
          >
            {amount && numberToWords(amount?.replace(/,/g, ""))}{" "}
            {amount?.replace(/,/g, "") > 0 && " dollars"}
          </Typography>
          {error && typeof error === "string" && (
            <Typography color="#EF233C" fontStyle={"italic"} fontSize={14}>
              {error}
            </Typography>
          )}
        </Box>

        {/* Withdraw Button */}
        <Box display="flex" justifyContent="end">
          <ButtonComponents
            sx={{ px: 2, py: 1, fontSize: 13, cursor: submitting ? "not-allowed" : "pointer" }}
            disabled={
              !amount ||
              parseInt(amount.replace(/[^0-9.]/g, "")) <= 0 ||
              submitting
            }
            label={"Withdraw funds"}
            onClick={handleWithdrwalFunds}
          />
        </Box>
      </Box>

      {/* Pending Withdrawal Requests */}
      <Typography variant="h6" fontWeight="semibold" gutterBottom>
        Pending Withdrawal Requests
      </Typography>
      {withdrawalHistory.length > 0 ? (
        <List
          ref={historyRef}
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column-reverse",
          }}
        >
          {withdrawalHistory.map((item) => {
            return (
              <Box
                key={item.id}
                bgcolor="#fff"
                borderRadius={1}
                mb={1}
                sx={{ boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.1)" }}
              >
                <ListItem sx={{ px: 3, py: 1.25 }}>
                  <ListItemText
                    sx={{ m: 0 }}
                    primary={
                      <Box display="flex" justifyContent="space-between">
                        <Typography
                          fontWeight={500}
                          color="#3B3B3B"
                          fontSize={{ md: 16, lg: 18 }}
                          variant="body2"
                        >
                          Withdrawal Requested{" "}
                          <span className="font-medium text-sm text-[#3B3B3B]">
                            (
                            {item.transactionStatus?.toLowerCase() ===
                              "approved"
                              ? "In-progress"
                              : "Pending"}
                            )
                          </span>
                        </Typography>
                        <Typography
                          fontWeight={600}
                          color="#3B3B3B"
                          fontSize={{ md: 16, lg: 18 }}
                        >
                          $
                          <NumberFormatter
                            amount={item.amount}
                          ></NumberFormatter>
                        </Typography>
                      </Box>
                    }
                    secondary={
                      <Box
                        display="flex"
                        mt={"12px"}
                        justifyContent="space-between"
                        alignItems={"center"}
                      >
                        <Typography
                          fontWeight={500}
                          color="#3B3B3B"
                          fontSize={{ md: 12, lg: 14 }}
                          variant="body2"
                        >
                          <DateFormatter
                            date={item.CompletedAt || item.initiatedAt}
                          />
                          { }
                        </Typography>
                        {item.transactionStatus === "PENDING" && (
                          <ButtonComponents
                            variant="outlined"
                            sx={{ px: 2, m: 0, fontSize: 14 }}
                            label="Cancel Request"
                            onClick={() => handleOpenDialog(item.transactionId)}
                          />
                        )}
                      </Box>
                    }
                  />
                </ListItem>
              </Box>
            );
          })}
        </List>
      ) : (
        <div
          ref={historyRef}
          className="min-h-80 flex justify-center items-center bg-white "
        >
          <Typography fontWeight={"500"} color="#9FA4AB">
            {" "}
            No information available
          </Typography>{" "}
        </div>
      )}
    </Box>
    </>
  );
};

export default WithdrawalFunds;
